import { render, staticRenderFns } from "./CustomersIcon.vue?vue&type=template&id=6e1cae9c&scoped=true"
var script = {}
import style0 from "./CustomersIcon.vue?vue&type=style&index=0&id=6e1cae9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1cae9c",
  null
  
)

export default component.exports